import { Breakpoint, Dialog, DialogActions, DialogContent } from "@mui/material";
import { MprcDialogTitleClose } from "components";
import * as React from "react";

//////////////////////////////////////////
interface IProps {
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    message: React.ReactNode;
    actions?: React.ReactNode;
    actionsPosition?: "start" | "center" | "end" | "space-between";
    width?: Breakpoint;
    onClose: () => void;
}
//////////////////////////////////////////

export const MprcSimpleDialog: React.FC<IProps> = (props) => {
    const { title, subtitle, message, onClose, actions, actionsPosition = "center", width = "md" } = props;

    return (
        <Dialog
            open
            fullWidth
            maxWidth={width}
            onClose={(e, reason) => reason == "escapeKeyDown" && onClose()}
        >
            <MprcDialogTitleClose
                shrinkPadding
                title={title}
                subtitle={subtitle}
                onClose={() => onClose()}
            />
            <DialogContent>
                {message}
            </DialogContent>
            <DialogActions style={{ justifyContent: actionsPosition }}>
                {actions}
            </DialogActions>
        </Dialog>
    );
};
